/**
 * Single message bubble for the chat UI.
 * Renders markdown-style bold (**text**) and line breaks. Deliberately minimal —
 * we do NOT want to render arbitrary HTML or user-controlled markdown.
 */

interface Props {
  role: 'user' | 'assistant';
  content: string;
  timestamp?: string;
}

export function SupportChatMessage({ role, content, timestamp }: Props) {
  return (
    <div className={`chat-msg chat-msg-${role}`}>
      <div className="chat-msg-bubble">{renderSafeMarkdown(content)}</div>
      {timestamp && <div className="chat-msg-time">{timestamp}</div>}
    </div>
  );
}

/**
 * Lightweight, safe markdown renderer. Handles:
 *  - **bold** → <strong>
 *  - line breaks → <br>
 * Anything else is escaped and rendered as plain text.
 */
function renderSafeMarkdown(text: string): JSX.Element {
  const parts = text.split(/(\*\*[^*]+\*\*|\n)/g);
  return (
    <>
      {parts.map((part, i) => {
        if (part === '\n') return <br key={i} />;
        const boldMatch = part.match(/^\*\*(.+)\*\*$/);
        if (boldMatch) return <strong key={i}>{boldMatch[1]}</strong>;
        return <span key={i}>{part}</span>;
      })}
    </>
  );
}
